import { render } from "./FlowSettingsAutomation.vue?vue&type=template&id=a9e1b23c&scoped=true"
import script from "./FlowSettingsAutomation.vue?vue&type=script&lang=ts"
export * from "./FlowSettingsAutomation.vue?vue&type=script&lang=ts"

import "./FlowSettingsAutomation.vue?vue&type=style&index=0&id=a9e1b23c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9e1b23c"

export default script